"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility to split props based on an array of keys
 */
function splitProps(props, keys) {
    const matchedProps = {};
    const remainingProps = {};
    const propKeys = Object.keys(props);
    for (let i = 0; i < propKeys.length; i++) {
        const propKey = propKeys[i];
        const propValue = props[propKey];
        if (keys.includes(propKey)) {
            matchedProps[propKey] = propValue;
        }
        else {
            remainingProps[propKey] = propValue;
        }
    }
    return { matchedProps, remainingProps };
}
exports.default = splitProps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BsaXQtcHJvcHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvc3BsaXQtcHJvcHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFXQTs7R0FFRztBQUNILFNBQXdCLFVBQVUsQ0FBK0MsS0FBUSxFQUFFLElBQVM7SUFDbEcsTUFBTSxZQUFZLEdBQUcsRUFBZ0IsQ0FBQTtJQUNyQyxNQUFNLGNBQWMsR0FBRyxFQUFPLENBQUE7SUFDOUIsTUFBTSxRQUFRLEdBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQVEsQ0FBQTtJQUV6QyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUN4QyxNQUFNLE9BQU8sR0FBRyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDM0IsTUFBTSxTQUFTLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBRWhDLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsRUFBRTtZQUMxQixZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsU0FBUyxDQUFBO1NBQ2xDO2FBQU07WUFDTCxjQUFjLENBQUMsT0FBTyxDQUFDLEdBQUcsU0FBUyxDQUFBO1NBQ3BDO0tBQ0Y7SUFFRCxPQUFPLEVBQUMsWUFBWSxFQUFFLGNBQWMsRUFBQyxDQUFBO0FBQ3ZDLENBQUM7QUFqQkQsNkJBaUJDIn0=